import { render } from "./Squads.vue?vue&type=template&id=18cde1e4"
import script from "./Squads.vue?vue&type=script&lang=js"
export * from "./Squads.vue?vue&type=script&lang=js"

import "./Squads.vue?vue&type=style&index=0&id=18cde1e4&scoepd=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__